import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { authSelectors } from '@rosetta/react-auth';
import { lionSelectors } from '@rosetta/react-lion';

import { skipAssessment } from '../services/launchpad-api';
import { emitEvent, PRODUCT_LAUNCHED } from '../../../helpers/eventingHelper';
import { getTargetLanguageCode } from '../../app/util/user-helper';

import {
  appMainBackground,
  appTextColor,
  blueHoverColor,
  lightBlueColor,
  white
} from '../../../styles/colors';

import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

const CopyContainer = styled.div((props) => {
  let style = {
    background: !props.isMobile ? white : appMainBackground,
    cursor: 'default',
    margin: !props.isMobile ? '30px auto 0' : '20px 16px 0',
    position: 'relative',
    textAlign: 'left',
    width: !props.isMobile ? '1000px' : 'auto',
    boxShadow: !props.isMobile ? '2px 2px 6px 0 rgba(0, 0, 0, 0.07)' : 'none',
    borderRadius: '4px'
  };
  return style;
});

const CopyWrapper = styled.div((props) => {
  let style = {
    boxSizing: 'border-box',
    color: appTextColor,
    margin: !props.isMobile ? '30px auto 0' : '20px 16px 0',
    cursor: 'default',
    display: 'block',
    fontSize: '16px',
    lineHeight: '18px',
    padding: !props.isMobile ? '0 100px 75px' : '0',
    textAlign: 'left',
    userSelect: 'none'
  };
  return style;
});

const NavArea = styled.div((props) => {
  let style = {
    display: 'block',
    padding: !props.isMobile ? '20px 0' : '16px',
    width: !props.isMobile ? '1000px' : 'auto',
    margin: 'auto',
    textAlign: 'right'
  };
  return style;
});

const BackButton = styled.div({
  backgroundColor: appMainBackground,
  border: '2px solid ' + lightBlueColor,
  borderRadius: '4px',
  color: lightBlueColor,
  cursor: 'pointer',
  display: 'inline-block',
  fontSize: '14px',
  fontWeight: '400',
  height: '40px',
  letterSpacing: '1px',
  lineHeight: '36px',
  margin: '0 10px',
  padding: '0 40px',
  textAlign: 'center',
  width: 'auto',
  ':hover': {
    backgroundColor: blueHoverColor,
    color: white
  }
});

const NextButton = styled.div({
  backgroundColor: lightBlueColor,
  border: '2px solid ' + lightBlueColor,
  borderRadius: '4px',
  color: white,
  cursor: 'pointer',
  display: 'inline-block',
  fontWeight: '400',
  fontSize: '14px',
  height: '40px',
  ':hover': {
    backgroundColor: blueHoverColor
  },
  letterSpacing: '1px',
  lineHeight: '38px',
  margin: '0 0 0 10px',
  padding: '0 40px',
  textAlign: 'center',
  width: 'auto'
});

const CopyLabel = styled.div((props) => {
  let style = {
    marginTop: '11px',
    padding: !props.isMobile ? '52px 0 0 100px' : '0',
    fontSize: '20px',
    fontWeight: 'normal',
    color: appTextColor,
    cursor: 'default',
    display: 'block',
    lineHeight: '18px',
  };
  return style;
});

export class StartOrSkipAssessment extends Component {

  handleSkip = () => {
    console.log('this.props.recommendation', this.props.recommendation);
    skipAssessment(this.props.recommendation.id, this.props.authToken).then(response => {
      console.log('response from skip assessment', response);
      if (response.id) {
        // Success
        console.log('SUCCESS!', window.location.pathname);
        const launchpadUri = window.location.origin + '/';
        window.location = launchpadUri;
      } else {
        // Throw error?
        throw new Error(JSON.stringify(response));
      }

    });
  }

  handleLaunchTest = () => {
    const link = this.props.recommendation.recommendation;
    emitEvent(PRODUCT_LAUNCHED, { url: link });
    console.log('StartOrSkipAssessment:142 location.assign');
    window.location.assign(link);
  }


  render = () => {
    const isMobile = isMobileDetected;
    const learningLanguageCode = getTargetLanguageCode(this.props.userInfo);
    const localizedL2Name = learningLanguageCode
      ? this.props.getLionTranslatedString('quest_full_language_' + learningLanguageCode)
      : '';
    const rawMessageText = this.props.getLionTranslatedString('quest_beginner_prompt');
    const messageText = rawMessageText.replace('{L2}', localizedL2Name);
    return (
      <div>
        <CopyContainer isMobile={isMobile}>
          <CopyLabel isMobile={isMobile}>
            {this.props.getLionTranslatedString('login_welcome')}
          </CopyLabel>
          <CopyWrapper isMobile={isMobile}>
            {messageText}
          </CopyWrapper>
        </CopyContainer>
        <NavArea isMobile={isMobile}>
          <BackButton onClick={() => this.handleSkip()}>
            {this.props.getLionTranslatedString('quest_beginner_skip_the_test_button')}
          </BackButton>
          <NextButton data-qa="NextButton" onClick={() => this.handleLaunchTest()}>
            {this.props.getLionTranslatedString('quest_beginner_take_the_test_button')}
          </NextButton>
        </NavArea>
      </div>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  userInfo: authSelectors.userInfo(state),
  authToken: authSelectors.authToken(state),
  getLionTranslatedString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});



export const StartOrSkipAssessmentContainer = connect(
  mapStateToProps,
  {}
)(withWindowDimensions(StartOrSkipAssessment));



// WEBPACK FOOTER //
// ./src/modules/launchpad/components/StartOrSkipAssessment.jsx